import axios, {AxiosResponse} from 'axios'
import {getCookie} from '../../../../../utils/cookie'
const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const UPLOAD_FRONTCCCD = `${API_URL}/v1/ekyc/images/upload-2`

const uploadCccd = async (file: any) => {
  const response = await axios.post(UPLOAD_FRONTCCCD, file, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
      'session-id': getCookie('SESSION_ID'),
    },
  })
  return response.data
}

export default uploadCccd
